export default () => {
  const $btn = $('.m-back');
  const $footer = $('.p-footer');

  $(window).scroll(function () {
    let _documentsHeight = $(document).height();
    let _windowHeight = $(window).height();
    let _footrHeight = $footer.height();
    let _top = $(this).scrollTop();

    if (_documentsHeight - _windowHeight -  _footrHeight < _top) {
      $btn.addClass("is-bottom");
    }else{
      $btn.removeClass("is-bottom");
    }

    if (200 < _top) {
      $btn.addClass("is-scrolled");
    }else{
      $btn.removeClass("is-scrolled");
    }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/utilities/backToTop.js